import { Router, Switch } from "react-router-dom";
import { history } from "./helpers/history";
import { Redirect, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Tooltip } from "react-tooltip";

import "./css/iphone.css";
import "./css/style.css";
import "./css/bootstrap.min.css";
import "./css/sb-admin-2.css";

import { defaultTheme } from "./themes/Default/default.theme";
import { ThemeProvider } from "styled-components";
import { GlobalStyle } from "./Styles/global";

import Login from "./Pages/Login/login.component";
import ForgottenPassword from "./Pages/ForgottenPassword/forgotten-password.component";
import ResetPassword from "./Pages/ResetPassword/reset-password.component";
import Home from "./Pages/Home/home.component";
import { useState } from "react";
import { ApolloProvider } from "@apollo/client";
import client from "./Apollo";
import ReactGA from "react-ga4";

var Bugsnag = require("@bugsnag/js");
var BugsnagPluginReact = require("@bugsnag/plugin-react");

Bugsnag.start({
	plugins: [new BugsnagPluginReact()],
	appVersion: process.env.REACT_APP_VERSION,
	apiKey: process.env.REACT_APP_BUGSNAGKEY,
	releaseStage: process.env.REACT_APP_BUGSNAGSTAGE,
	onError: function (event) {
		console.log("event", event);
		if (event.originalError.indexOf("ResizeObserver") !== -1) {
			//console.log("attempting to skip");
			return false;
		}
		if (
			event.originalError.indexOf("Malformed Authorization header") !== -1
		) {
			//console.log("attempting to skip");
			return false;
		}
		if (event.originalError.indexOf("Error Could not verify JWT") !== -1) {
			//console.log("attempting to skip");
			return false;
		}
		event.setUser(localStorage.getItem("user_id"), "", "");
	},
});

const App = () => {
	const [theme, setTheme] = useState();
	ReactGA.initialize(process.env.REACT_APP_GOOGLEANALYTICS);

	history.listen((location) => {
		//console.log("changed page");
		ReactGA.set({ page: location.pathname }); // Update the user's current page
		ReactGA.send({ hitType: "pageview", page: location.pathname }); // Record a pageview for the given page
	});

	const getThemeFromAPI = async () => {
		const url = window.location.hostname;
		if (!theme) {
			console.log(
				`${process.env.REACT_APP_API_URL}theme/` + url,
				"< fetch url"
			);
			const response = await fetch(
				`${process.env.REACT_APP_API_URL}theme/` + url,
				{ method: "GET" }
			);
			if (response && response.status === 200) {
				const json = await response.json();
				if (json) {
					console.log(json, "< json theming");
					setTheme(json);
				} else {
					setTheme(getTheme());
				}
			}
		}
	};

	const getTheme = () => {
		return defaultTheme;
	};
	//console.log("about to get theme")
	getThemeFromAPI();
	if (!theme) return null;
	return (
		<ThemeProvider theme={theme}>
			<Helmet>
				<link rel="icon" href={theme?.images?.favIcon} />
				<title>{theme?.appName}</title>
			</Helmet>
			<GlobalStyle />
			<ApolloProvider client={client}>
				<Router history={history}>
					<Switch>
						{/* Public Routes */}
						<Route
							exact
							path="/"
							render={() => {
								return <Redirect to="/login" />;
							}}
						/>
						<Route exact path="/login">
							<Login />
						</Route>
						<Route exact path="/forgotten-password">
							<ForgottenPassword />
						</Route>
						<Route exact path="/reset-password">
							<ResetPassword />
						</Route>
						{/* Private Routes */}
						<Route>
							<Home />
						</Route>
					</Switch>
				</Router>
			</ApolloProvider>
			<Tooltip className="tooltip" effect="solid" />
		</ThemeProvider>
	);
};

export default App;
